import { css } from 'emotion';

export const fullscreenControl = css`
  && {
    // Overwrites leaflet leaflet-control styles
    margin-left: 0;
  }
`;
